// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__3IYQk","logos":"style_logos__Kf5Wi"};